export default [
  {
    path: "/produto",
    name: "product",
    component: () => import("../views/product/Index.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["gerenciar-produtos"],
      viewContainer: true,
      breadcrumbs: ["product"]
    }
  },

  // COPRODUTOR
  {
    path: "/produto/coprodutor/:id/links",
    name: "coproducer-product-links",
    component: () => import("../views/product/coproducer/ProductLinks.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["gerenciar-produtos"],
      viewContainer: true,
      breadcrumbs: ["product", "coproducer-product-links"]
    }
  },

  // CRIAR PRODUTO
  // {
  //   path: "/produto/novo",
  //   name: "product-new",
  //   component: () => import("../views/product/New.vue"),
  //   meta: {
  //     template: () => import("../templates/Default.vue"),
  //     breadcrumbs: ["product-new"],
  //     protected: true,
  //     permissions: ["gerenciar-produtos"],
  //     viewContainer: true
  //   }
  // },
  // {
  //   path: "/produto/novo/curso",
  //   name: "product-new-online-course",
  //   component: () => import("../views/product/NewCourse.vue"),
  //   meta: {
  //     template: () => import("../templates/Default.vue"),
  //     protected: true,
  //     breadcrumbs: ["product-new", "product-new-online-course"],
  //     permissions: ["gerenciar-produtos"],
  //     viewContainer: true
  //   }
  // },
  // {
  //   path: "/produto/novo/assinatura",
  //   name: "product-new-signature",
  //   component: () => import("../views/product/NewSignature.vue"),
  //   meta: {
  //     template: () => import("../templates/Default.vue"),
  //     breadcrumbs: ["product-new", "product-new-signature"],
  //     protected: true,
  //     permissions: ["gerenciar-produtos"],
  //     viewContainer: true
  //   }
  // },
  // {
  //   path: "/produto/novo/evento",
  //   name: "product-new-event",
  //   component: () => import("../views/product/events/NewEvent.vue"),
  //   meta: {
  //     template: () => import("../templates/Default.vue"),
  //     breadcrumbs: ["product-new", "product-new-event"],
  //     protected: true,
  //     permissions: ["gerenciar-produtos"],
  //     viewContainer: true
  //   }
  // },

  {
    path: "/produto/:id",
    component: () => import("@/layouts/ProductLayout.vue"),
    children: [
      // DETALHES
      {
        path: "",
        name: "product-details",
        component: () => import("../views/product/Details.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          sidemenu: {
            component: () => import("../components/product/SideMenu.vue"),
            url_match: "/produto/"
          },
          breadcrumbs: ["product", "product-details"],
          permissions: ["gerenciar-produtos"],
          viewContainer: true,
          protected: true
        }
      },

      // INFORMAÇÕES BÁSICAS
      {
        path: "/produto/:id/informacoes-basicas",
        name: "product-basic-info",
        component: () => import("@/views/product/BasicInfoConfig.vue"),
        meta: {
          template: () => import("@/templates/Default.vue"),
          breadcrumbs: ["product", "product-details", "product-basic-info"],
          protected: true,
          permissions: ["gerenciar-produtos"],
          viewContainer: true,
          aside: true
        }
      },
      {
        path: "/produto/:id/coprodutores",
        name: "product-coproducers",
        component: () => import("../views/product/ProductCoproducers.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          protected: true,
          breadcrumbs: ["product", "product-details", "product-coproducers"],
          permissions: ["gerenciar-produtos"],
          viewContainer: true
        }
      },

      // LINKS DE DIVULGAÇÃO
      {
        path: "/produto/:id/links",
        name: "product-links",
        component: () => import("../views/product/Links.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          sidemenu: {
            component: () => import("../components/product/SideMenu.vue"),
            url_match: "/produto/links"
          },
          breadcrumbs: ["product", "product-details", "product-links"],
          protected: true,
          permissions: ["gerenciar-produtos"],
          viewContainer: true
        }
      },

      // ONE CLICK BUY
      {
        path: "/produto/:id/oneclickbuy",
        name: "product-oneclickbuy",
        component: () => import("../views/product/OneClickBuy.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          sidemenu: {
            component: () => import("../components/product/SideMenu.vue"),
            url_match: "/produto/oneclickbuy"
          },
          breadcrumbs: ["product", "product-details", "product-oneclickbuy"],
          protected: true,
          permissions: ["gerenciar-produtos"],
          viewContainer: true
        }
      },

      // EVENTO
      {
        path: "ingressos",
        name: "event-lots",
        component: () => import("../views/product/events/Lots.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          protected: true,
          breadcrumbs: ["product", "product-details", "event-lots"],
          permissions: ["gerenciar-produtos", "gerenciar-eventos"],
          viewContainer: true
        }
      },
      {
        path: "ingressos/novo",
        name: "event-new-lot",
        component: () => import("../views/product/events/LotData.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          breadcrumbs: [
            "product",
            "product-details",
            "event-lots",
            "event-new-lot"
          ],
          protected: true,
          permissions: ["gerenciar-produtos", "gerenciar-eventos"],
          viewContainer: true
        }
      },
      {
        path: "ingressos/:lot_code",
        name: "event-edit-lot",
        component: () => import("../views/product/events/LotData.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          breadcrumbs: [
            "product",
            "product-details",
            "event-lots",
            "event-edit-lot"
          ],
          protected: true,
          permissions: ["gerenciar-produtos", "gerenciar-eventos"],
          viewContainer: true
        }
      },
      {
        path: "participantes",
        name: "event-participants",
        component: () =>
          import("../views/product/events/EventParticipants.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          breadcrumbs: ["product", "product-details", "event-participants"],
          protected: true,
          permissions: ["gerenciar-produtos", "gerenciar-participantes"],
          viewContainer: true
        }
      },

      // CUPOM
      {
        path: "cupons",
        name: "product-coupons",
        component: () => import("../views/product/coupons/CouponList.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          breadcrumbs: ["product", "product-details", "product-coupons"],
          protected: true,
          permissions: ["gerenciar-produtos"],
          viewContainer: true
        }
      },

      // PRECIFICAÇÃO
      {
        path: "/produto/:id/precos",
        name: "product-prices",
        component: () => import("../views/product/pricing/Prices.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          sidemenu: {
            component: () => import("../components/product/SideMenu.vue"),
            url_match: "/produto/precos"
          },
          breadcrumbs: ["product", "product-details", "product-prices"],
          protected: true,
          permissions: ["gerenciar-produtos", "gerenciar-ofertas"],
          viewContainer: true
        }
      },
      {
        path: "/produto/:id/planos",
        name: "product-plans",
        component: () => import("../views/product/pricing/Plans.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          sidemenu: {
            component: () => import("../components/product/SideMenu.vue"),
            url_match: "/planos"
          },
          breadcrumbs: ["product", "product-details", "product-plans"],
          protected: true,
          permissions: ["gerenciar-produtos", "gerenciar-ofertas"],
          viewContainer: true
        }
      },
      {
        path: "/produto/:id/planos/novo",
        name: "product-plans-new",
        component: () => import("../views/product/pricing/PlanInformation.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          sidemenu: {
            component: () => import("../components/product/SideMenu.vue"),
            url_match: "/planos/novo"
          },
          breadcrumbs: ["product", "product-details", "product-plans"],
          protected: true,
          permissions: ["gerenciar-produtos", "gerenciar-ofertas"],
          viewContainer: true
        }
      },
      {
        path: "/produto/:id/planos/:plan_id",
        name: "product-plans-edit",
        component: () => import("../views/product/pricing/PlanInformation.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          sidemenu: {
            component: () => import("../components/product/SideMenu.vue"),
            url_match: "/planos/:plan_id"
          },
          breadcrumbs: ["product", "product-details", "product-plans"],
          protected: true,
          permissions: ["gerenciar-produtos", "gerenciar-ofertas"],
          viewContainer: true
        }
      },
      {
        path: "/produto/:id/precos/novo",
        name: "product-prices-new",
        component: () => import("../views/product/pricing/Offer.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          sidemenu: {
            component: () => import("../components/product/SideMenu.vue"),
            url_match: "/precos/novo"
          },
          breadcrumbs: [
            "product",
            "product-details",
            "product-prices",
            "product-prices-new"
          ],
          protected: true,
          permissions: ["gerenciar-produtos", "gerenciar-ofertas"],
          viewContainer: true
        }
      },
      {
        path: "/produto/:id/precos/oferta-principal",
        name: "product-prices-main",
        component: () => import("../views/product/pricing/EditMainOffer.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          protected: true,
          permissions: ["gerenciar-produtos", "gerenciar-ofertas"],
          viewContainer: true,
          aside: true,
          breadcrumbs: [
            "product",
            "product-details",
            "product-prices",
            "product-prices-main"
          ]
        }
      },
      {
        path: "/produto/:id/precos/:offer_id",
        name: "product-prices-edit",
        component: () => import("../views/product/pricing/Offer.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          sidemenu: {
            component: () => import("../components/product/SideMenu.vue"),
            url_match: "/precos/:offer_id"
          },
          breadcrumbs: [
            "product",
            "product-details",
            "product-prices",
            "product-prices-edit"
          ],
          protected: true,
          permissions: ["gerenciar-produtos", "gerenciar-ofertas"],
          viewContainer: true
        }
      },

      // CONVERSÕES
      {
        path: "conversoes",
        name: "product-analytics",
        component: () => import("../views/product/Analytics.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          sidemenu: {
            component: () => import("../components/product/SideMenu.vue"),
            url_match: "/conversoes"
          },
          protected: true,
          permissions: ["gerenciar-produtos"],
          viewContainer: true,
          breadcrumbs: ["product", "product-details", "product-analytics"]
        }
      },
      {
        path: "conversoes/facebook-api",
        name: "product-facebook-pixel",
        component: () => import("../views/product/FacebookPixel.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          sidemenu: {
            component: () => import("../components/product/SideMenu.vue"),
            url_match: "/conversoes"
          },
          protected: true,
          permissions: ["gerenciar-produtos"],
          breadcrumbs: [
            "product",
            "product-details",
            "product-analytics",
            "product-facebook-pixel"
          ],
          viewContainer: true
        }
      },
      {
        path: "conversoes/google-analytics",
        name: "product-google-analytics",
        component: () => import("../views/product/GoogleAnalytics.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          sidemenu: {
            component: () => import("../components/product/SideMenu.vue"),
            url_match: "/conversoes"
          },
          protected: true,
          permissions: ["gerenciar-produtos"],
          breadcrumbs: [
            "product",
            "product-details",
            "product-analytics",
            "product-google-analytics"
          ],
          viewContainer: true
        }
      },

      // ALUNOS
      {
        path: "membros/alunos",
        name: "product-member-area-students",
        component: () => import("../views/product/MemberAreaStudents.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          sidemenu: {
            component: () => import("../components/product/SideMenu.vue"),
            url_match: "/membros/alunos"
          },
          protected: true,
          permissions: ["gerenciar-produtos"],
          viewContainer: true,
          breadcrumbs: [
            "product",
            "product-details",
            "product-member-area-students"
          ]
        }
      },

      // TURMAS
      {
        path: "membros/turmas",
        name: "product-member-area-groups",
        component: () => import("../views/product/MemberAreaGroups.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          sidemenu: {
            component: () => import("../components/product/SideMenu.vue"),
            url_match: "/membros/turmas"
          },
          protected: true,
          permissions: ["gerenciar-produtos"],
          viewContainer: true,
          breadcrumbs: [
            "product",
            "product-details",
            "product-member-area-groups"
          ]
        }
      },
      {
        path: "membros/turmas/adicionar",
        name: "product-member-area-groups-add",
        component: () => import("../views/product/RegisterGroup.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          sidemenu: {
            component: () => import("../components/product/SideMenu.vue"),
            url_match: "/membros/turmas"
          },
          protected: true,
          permissions: ["gerenciar-produtos"],
          viewContainer: true,
          breadcrumbs: [
            "product",
            "product-details",
            "product-member-area-groups",
            "product-member-area-groups-add"
          ]
        }
      },
      {
        path: "membros/turmas/editar/:group",
        name: "product-member-area-groups-edit",
        component: () => import("../views/product/RegisterGroup.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          sidemenu: {
            component: () => import("../components/product/SideMenu.vue"),
            url_match: "/membros/turmas"
          },
          protected: true,
          permissions: ["gerenciar-produtos"],
          viewContainer: true,
          breadcrumbs: [
            "product",
            "product-details",
            "product-member-area-groups",
            "product-member-area-groups-edit"
          ]
        }
      },

      // COMENTÁRIOS
      {
        path: "membros/comentarios",
        name: "product-member-area-comments",
        component: () => import("../views/product/MemberAreaComments.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          sidemenu: {
            component: () => import("../components/product/SideMenu.vue"),
            url_match: "/membros/comentarios"
          },
          protected: true,
          permissions: ["gerenciar-produtos"],
          viewContainer: true,
          breadcrumbs: [
            "product",
            "product-details",
            "product-member-area-comments"
          ]
        }
      }
    ]
  },

  // CHECKOUT BUILDER
  {
    path: "/produto/:id/personalizar-checkout",
    name: "product-customize-checkout",
    component: () => import("../views/product/checkout/CheckoutBuilder.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue")
      },
      protected: true,
      permissions: ["gerenciar-produtos", "configurar-checkout"],
      viewContainer: true
    }
  },

  // COPRODUTORES
  {
    path: "/produto/:id/coprodutores/adicionar",
    name: "product-coproducers-add",
    component: () => import("../views/product/RegisterCoProducer.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      // sidemenu: {
      //   component: () => import("./components/product/SideMenu.vue"),
      //   url_match: "/coprodutores/adicionar"
      // },
      protected: true,
      permissions: ["gerenciar-produtos"],
      viewContainer: true
    }
  },

  // CHECKOUT
  {
    path: "/produto/:id/checkout",
    name: "product-checkout",
    component: () => import("../views/product/checkout/CheckoutConfig.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["gerenciar-produtos", "configurar-checkout"],
      viewContainer: true,
      breadcrumbs: ["product", "product-details", "product-checkout"]
    }
  },

  // PRECIFICACAO
  // {
  //   path: "/produto/:id/precos",
  //   name: "product-prices",
  //   component: () => import("../views/product/pricing/Prices.vue"),
  //   meta: {
  //     template: () => import("../templates/Default.vue"),
  //     sidemenu: {
  //       component: () => import("../components/product/SideMenu.vue"),
  //       url_match: "/precos"
  //     },
  //     protected: true,
  //     permissions: ["gerenciar-produtos", "gerenciar-ofertas"],
  //     viewContainer: true
  //   }
  // },
  // {
  //   path: "/produto/:id/planos",
  //   name: "product-plans",
  //   component: () => import("../views/product/pricing/Plans.vue"),
  //   meta: {
  //     template: () => import("../templates/Default.vue"),
  //     sidemenu: {
  //       component: () => import("../components/product/SideMenu.vue"),
  //       url_match: "/planos"
  //     },
  //     protected: true,
  //     permissions: ["gerenciar-produtos", "gerenciar-ofertas"],
  //     viewContainer: true
  //   }
  // },

  // UPSELL
  {
    path: "/produto/:id/upsell",
    name: "product-upsell",
    component: () => import("../views/product/UpSell.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/upsell"
      },
      protected: true,
      permissions: ["gerenciar-produtos"]
    }
  },
  {
    path: "/produto/:id/upsell/novo",
    name: "product-upsell-new",
    component: () => import("../views/product/UpSellNew.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/upsell/novo"
      },
      protected: true,
      permissions: ["gerenciar-produtos"]
    }
  },
  {
    path: "/produto/:id/upsell/:tree",
    name: "product-upsell-tree",
    component: () => import("../views/product/UpsellTree.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/upsell"
      },
      protected: true,
      permissions: ["gerenciar-produtos"]
    }
  },
  {
    path: "/produto/:id/upsell/editar/:funnel",
    name: "product-upsell-edit",
    component: () => import("../views/product/UpSellNew.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/upsell/novo"
      },
      protected: true,
      permissions: ["gerenciar-produtos"]
    }
  },

  // PIXEL DE RASTREAMENTO
  {
    path: "/produto/:id/pixel",
    name: "product-edit-pixel",
    component: () => import("../views/product/Pixel.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/pixel"
      },
      protected: true,
      permissions: ["gerenciar-produtos"],
      viewContainer: true,
      breadcrumbs: ["product", "product-details", "product-edit-pixel"]
    }
  },

  // CONFIGURAR AREA DE MEMBROS
  {
    path: "/produto/:id/membros/configurar",
    name: "product-member-area-setup",
    component: () => import("../views/product/MemberAreaSetup.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/membros/configurar"
      },
      protected: true,
      permissions: ["gerenciar-produtos"],
      viewContainer: true
    }
  },

  // CONTEÚDO
  {
    path: "/produto/:id/membros/modulos",
    name: "product-member-area-modules",
    component: () => import("../views/product/MemberAreaModules.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      viewContainer: true,
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/membros/modulos"
      },
      protected: true,
      permissions: ["gerenciar-produtos"]
    }
  },
  {
    path: "/produto/:id/membros/modulos/:module_id",
    name: "product-member-area-modules-detail",
    component: () => import("../views/product/MemberAreaModuleDetail.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      viewContainer: true,
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/membros/modulos"
      },
      protected: true,
      permissions: ["gerenciar-produtos"]
    }
  },
  {
    path: "/produto/:id/membros/modulo/adicionar",
    name: "product-members-module-add",
    component: () => import("../views/product/RegisterModule.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/membros/modulo"
      },
      protected: true,
      permissions: ["gerenciar-produtos"],
      viewContainer: true
    }
  },
  {
    path: "/produto/:id/membros/modulo/editar/:module_id",
    name: "product-members-module-edit",
    component: () => import("../views/product/RegisterModule.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/membros/modulo"
      },
      protected: true,
      permissions: ["gerenciar-produtos"],
      viewContainer: true
    }
  },
  {
    path: "/produto/:id/membros/aula/adicionar",
    name: "product-members-lesson-add",
    component: () => import("../views/product/RegisterLesson.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/membros/modulo"
      },
      protected: true,
      permissions: ["gerenciar-produtos"],
      viewContainer: true
    }
  },
  {
    path: "/produto/:id/membros/aula/editar/:lesson",
    name: "product-members-lesson-edit",
    component: () => import("../views/product/RegisterLesson.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/membros/modulo"
      },
      protected: true,
      permissions: ["gerenciar-produtos"],
      viewContainer: true
    }
  },
  {
    path: "/produto/:id/membros/:module_id/submodulo/adicionar",
    name: "product-members-submodule-add",
    component: () => import("../views/product/RegisterSubModule.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/membros/modulo"
      },
      protected: true,
      permissions: ["gerenciar-produtos"],
      viewContainer: true
    }
  },
  {
    path:
      "/produto/:id/membros/modulo/:module_id/submodulo/:submodule_id/editar",
    name: "product-members-submodule-edit",
    component: () => import("../views/product/RegisterSubModule.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/membros/modulo"
      },
      protected: true,
      permissions: ["gerenciar-produtos"],
      viewContainer: true
    }
  },
  {
    path: "/produto/:id/membros/quiz/adicionar",
    name: "product-module-quiz-add",
    component: () => import("../views/product/RegisterModuleQuiz.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["gerenciar-produtos"]
    }
  },
  {
    path: "/produto/:id/membros/quiz/adicionar/question",
    name: "product-module-quiz-add-question",
    component: () => import("../views/product/RegisterModuleQuizQuestion.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["gerenciar-produtos"]
    }
  },

  // CATEGORIAS
  {
    path: "/produto/:id/membros/categorias",
    name: "product-member-area-categories",
    component: () => import("../views/product/MemberAreaCategories.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/membros/modulos"
      },
      protected: true,
      permissions: ["gerenciar-produtos"],
      viewContainer: true
    }
  },

  {
    path: "/produto/:id/ferramentas/coprodutores/adicionar",
    name: "product-coproducers-add-tools",
    component: () =>
      import("../views/tools/account/RegisterCoProducersTools.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      // sidemenu: {
      //   component: () => import("./components/product/SideMenu.vue"),
      //   url_match: "/coprodutores/adicionar"
      // },
      protected: true,
      permissions: ["gerenciar-produtos"],
      viewContainer: true
    }
  },

  // Avaliações
  {
    path: "/produto/:id/membros/modulo/:module_id/avaliacao/adicionar",
    name: "product-members-module-quizz-add",
    component: () => import("../views/product/quizz/NewMemberAreaQuizz.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/membros/modulo"
      },
      protected: true,
      permissions: ["gerenciar-produtos"],
      viewContainer: true
    }
  },
  {
    path: "/produto/:id/membros/modulo/:module_id/avaliacao/:quizz_id",
    name: "product-members-module-quizz-edit",
    component: () => import("../views/product/quizz/NewMemberAreaQuizz.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/membros/modulo"
      },
      protected: true,
      permissions: ["gerenciar-produtos"],
      viewContainer: true
    }
  },
  {
    path: "/produto/:id/membros/avaliacao/final/adicionar",
    name: "product-members-module-quizz-final-add",
    component: () =>
      import("../views/product/quizz/NewFinalMemberAreaQuizz.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/membros/modulo"
      },
      protected: true,
      permissions: ["gerenciar-produtos"],
      viewContainer: true
    }
  },
  {
    path: "/produto/:id/membros/avaliacao/final/editar",
    name: "product-members-module-quizz-final-edit",
    component: () =>
      import("../views/product/quizz/NewFinalMemberAreaQuizz.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      sidemenu: {
        component: () => import("../components/product/SideMenu.vue"),
        url_match: "/membros/modulo"
      },
      protected: true,
      permissions: ["gerenciar-produtos"],
      viewContainer: true
    }
  }
];
